export const enum LockType {
  Normal = 1,
  Blind = 2,
  DoubleBlind = 3,
}

export const isFlagViewCreatorBlackedOut = (lockType: number, canViewFlag: boolean): boolean =>
  lockType === LockType.DoubleBlind && !canViewFlag

export const isFlagViewAssignedToBlackedOut = (
  lockType: number,
  assignedToId: number | undefined,
  currentUserId: number,
  canViewFlag: boolean
): boolean => {
  if (!assignedToId) return false
  return lockType >= LockType.Blind && !canViewFlag && assignedToId !== currentUserId
}

export const isFlagListPRIDBlackedOut = (lockType: number, canViewFlag: boolean): boolean =>
  lockType >= LockType.Blind && !canViewFlag

export const isFlagHeaderBlackedOut = (lockType: number, serviceType: string): boolean => {
  if (serviceType === 'Q') return true
  if (serviceType === 'H') return false
  return lockType >= LockType.Blind
}
